import mapValues from 'lodash/mapValues';
import toArray from 'lodash/toArray';
import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';
import { Scene, Module, ScenePayload } from '../components/scenes/scene-config/types';
import { AppConfigData } from '../types/app-config';

export function setSceneConfigValues(deviceScene: Record<string, Scene>): ScenePayload {
  const newScene = mapValues(deviceScene, (scene: Scene) => {
    const newFields = scene.modules.map((module) => {
      return module.fields.reduce((acc: any, field: any) => {
        return { ...acc, [field.key]: field.value, type: module.type };
      }, {});
    });

    const updatedScene = {
      condition: {
        modules: newFields,
        scene: scene.type,
        predefinedrule: 'DEFAULT',
      },
    };

    return updatedScene;
  });

  return toArray(newScene);
}

export function mapInitialSceneConfigValue(
  modules: Module[],
  initialSceneConfig: any,
  appConfig: AppConfigData
) {
  const scenes = initialSceneConfig.reduce((acc: any, current: any) => {
    const currentSceneName: string = current.condition.scene;
    const types: Module[] = current.condition.modules.map((apiModule: any) => {
      const moduleWithValue = modules.find((item) => item.type === apiModule.type);

      if (!moduleWithValue) {
        console.error('Module not found', apiModule);
        return null;
      }

      const moduleWithValueClone = cloneDeep(moduleWithValue);

      moduleWithValueClone.fields.forEach((field) => {
        if (field.key === 'divider') {
          field.value = apiModule[field.key] || false;
        } else {
          field.value = apiModule[field.key];
        }
      });

      // Filter out background color for promos
      moduleWithValueClone.fields = moduleWithValueClone.fields.filter((field) => {
        return !(field?.key === 'bgColor' && moduleWithValue?.type === 'MODULE_PROMO');
      });

      // Filter out empty promos (skip when team scene is selected)
      if (moduleWithValueClone.type === 'MODULE_PROMO' && currentSceneName !== 'TEAMSCENE') {
        const promoSelectField = moduleWithValueClone.fields.find((field) => {
          return field?.key === 'promoIndex';
        });
        if (promoSelectField?.options) {
          promoSelectField.options = promoSelectField.options.filter(
            (option) => appConfig.promos[parseInt(option)]
          );
        }
      }

      return { ...moduleWithValueClone, id: uuidv4() };
    });

    acc[currentSceneName] = {
      type: currentSceneName,
      modules: types,
    };

    return acc;
  }, {});

  return scenes;
}
